import { Autocomplete, TextField, autocompleteClasses } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { type Control, Controller } from "react-hook-form";
import type { IModalActionForm, IModalActionResolver } from "../logics/types";

export interface IModalActionFormChallengesProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
  disabled?: boolean;
}

export const ModalActionFormChallenges = ({ control, disabled }: IModalActionFormChallengesProps) => {
  const { challenges } = useGlobalContext();

  return (
    <Controller
      control={control}
      name="challenges"
      render={({ field: { value, onChange, onBlur, name, ref }, fieldState: { error } }) => (
        <Autocomplete
          value={value}
          onChange={(_, value) => onChange(value)}
          onBlur={onBlur}
          options={challenges}
          getOptionLabel={(option) => option.name}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          size="small"
          renderInput={(params) => (
            <TextField
              {...params}
              name={name}
              label="Thématiques liées"
              inputRef={ref}
              error={Boolean(error)}
              helperText={error?.message}
            />
          )}
          limitTags={1}
          multiple
          disabled={disabled}
          slotProps={{
            chip: { color: "yellow", size: "small", sx: { [`&.${autocompleteClasses.tag}`]: { mt: "1px", mb: 0 } } },
          }}
        />
      )}
    />
  );
};
